/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IRestaurantEvent } from '../custom-actions/DataServiceEntities.g';
import { getEventInfoAsync } from '../custom-actions/DataActionExtension.g';

export class ValidateEventInput implements Msdyn365.IActionInput {
    public eventId: string;

    constructor(eventId: string) {
        this.eventId = eventId;
    }

    public getCacheKey = () => `ValidateEvent_${this.eventId}`;
    public getCacheObjectType = () => 'ValidateEvent';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createValidateEventInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ValidateEventInput('');
};

export async function validateEventAction(input: ValidateEventInput, ctx: Msdyn365.IActionContext): Promise<IRestaurantEvent | undefined> {
    if (!input.eventId) {
        console.log('validateEventAction: eventId is required');
        return undefined;
    }
    try {
        console.log('validateEventAction: getting event info', input.eventId);
        const result = await getEventInfoAsync({ callerContext: ctx }, input.eventId);
        if (result) {
            console.log('validateEventAction: event is valid', result);
            return result;
        }
    } catch (error) {
        console.log('validateEventAction error:', error);
    }
    return undefined;
}

export const validateEvent = async (eventId: string, actionContext: Msdyn365.IActionContext): Promise<IRestaurantEvent | undefined> => {
    const input = new ValidateEventInput(eventId);
    return validateEventAction(input, actionContext);
};

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IRestaurantEvent | undefined>>validateEventAction,
    id: 'ValidateEvent',
    input: createValidateEventInput
});
